<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between" [ngClass]="{disabledContent: !enableClient}">
    <form autocomplete="off" [formGroup]="formHeader">

      <!-- Datos del cliente -->
      <div [ngClass]="{'row': true, disabledContent: !enableClient}">
        <ng-container *ngIf="permiteUnidadNegocio">
          <div>
            <div class="col">
              <div class="md-form">
                <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                  placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                </mdb-select>
                <div *ngIf="
                                        formHeader.get('unidad_negocio_codigo').invalid &&
                                        (formHeader.get('unidad_negocio_codigo').dirty ||
                                        formHeader.get('unidad_negocio_codigo').touched)
                                      ">
                  <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                    de negocio
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="col" style="max-width: 300px;">
          <div class="md-form m-0">
            <mdb-date-picker [inline]="true" name="fechaEmision" [placeholder]="'Fecha Emisión'" required
              formControlName="fechaEmision">
            </mdb-date-picker>
            <span *ngIf="
                                formHeader.get('fechaEmision').invalid &&
                                (formHeader.get('fechaEmision').dirty ||
                                formHeader.get('fechaEmision').touched)
                              ">
              <mdb-error *ngIf="formHeader.get('fechaEmision').hasError('required')">
                Ingrese fecha emisión
              </mdb-error>
            </span>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select label="Tipo traslado" [options]="optionsTipoTraslado" placeholder="Seleccionar Tipo traslado"
              [filterEnabled]="true" formControlName="tipoTraslado">
            </mdb-select>
            <span *ngIf="
                                            formHeader.get('tipoTraslado').invalid &&
                                            (formHeader.get('tipoTraslado').dirty ||
                                            formHeader.get('tipoTraslado').touched)
                                          ">
              <mdb-error *ngIf="ValidateError === true && formHeader.get('tipoTraslado').hasError('required')">
                Ingrese tipo traslado
              </mdb-error>
            </span>
          </div>
        </div>

        <div class="col" style="max-width: 400px;">
          <div class="md-form">
            <mdb-select label="Tipo de envio" [options]="optionsTipoEnvio" placeholder="Seleccionar Tipo envio"
              [filterEnabled]="true" formControlName="tipoEnvio"></mdb-select>
            <span *ngIf="
                                              formHeader.get('tipoEnvio').invalid &&
                                              (formHeader.get('tipoEnvio').dirty ||
                                              formHeader.get('tipoEnvio').touched)
                                            ">
              <mdb-error *ngIf="ValidateError === true && formHeader.get('tipoEnvio').hasError('required')">
                Ingrese tipo envío
              </mdb-error>
            </span>
          </div>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col" style="max-width: 300px" *ngIf="showBodegaSalida">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodegaSalida"></mdb-select>
            <label>Bodega Salida</label>
            <ng-container ngif="showBodegaSalida">
              <div
                *ngIf="formHeader.get('bodegaSalida').invalid && (formHeader.get('bodegaSalida').dirty || formHeader.get('bodegaSalida').touched)">
                <mdb-error *ngIf="formHeader.get('bodegaSalida').hasError('required')">Ingrese bodega salida
                </mdb-error>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="col" style="max-width: 300px" *ngIf="showBodegaEntrada">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodegaEntrada"></mdb-select>
            <label>Bodega Entrada</label>
            <div
              *ngIf="formHeader.get('bodegaEntrada').invalid && (formHeader.get('bodegaEntrada').dirty || formHeader.get('bodegaEntrada').touched)">
              <mdb-error *ngIf="formHeader.get('bodegaEntrada').hasError('required')">Ingrese bodega ingreso
              </mdb-error>
            </div>
          </div>
        </div>
      </div>

      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <input value="" type="text" id="rutprovedor" class="form-control" placeholder="9.999.999-9" required
              #rutprovedor formControlName="rutCliente" formatRut />
            <label for="rutprovedor">Rut de Cliente</label>
            <span *ngIf="
                              formHeader.get('rutCliente').invalid &&
                              (formHeader.get('rutCliente').dirty ||
                              formHeader.get('rutCliente').touched)
                            ">
              <mdb-error *ngIf="ValidateError === true && formHeader.get('rutCliente').hasError('required')">
                Ingrese cliente
              </mdb-error>
            </span>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="clienteSeleccionado;else mjsConsultaRut">
            {{ clienteSeleccionado?.razon_social }}
          </h6>
          <ng-template #mjsConsultaRut>
            <h6 class="text-info" style="display: contents;">Ingrese el RUT del cliente</h6>
          </ng-template>
        </div>
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar Sucursal"
              [filterEnabled]="true" formControlName="sucursal"></mdb-select>
            <span *ngIf="
                                            formHeader.get('sucursal').invalid &&
                                            (formHeader.get('sucursal').dirty ||
                                            formHeader.get('sucursal').touched)
                                          ">
              <mdb-error *ngIf="formHeader.get('sucursal').hasError('required')">
                Ingrese sucursal
              </mdb-error>
            </span>
          </div>
        </div>
      </div>

      <div class="row filtros-body">

        <div class="col dato">
          <Strong class="title">Dirección</Strong>
          <span class="value" *ngIf="sucursalSeleccionada?.direccion_completa; else dummyTxt">
            {{ sucursalSeleccionada?.direccion_completa }}
          </span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato">
          <Strong class="title">Comuna</Strong>
          <span class="value" *ngIf="sucursalSeleccionada?.nombreComuna; else dummyTxt">
            {{ sucursalSeleccionada?.nombreComuna }}
          </span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col dato">
          <Strong class="title">Provincia</Strong>
          <span class="value" *ngIf="sucursalSeleccionada?.nombreProvincia; else dummyTxt">
            {{ sucursalSeleccionada?.nombreProvincia }}
          </span>
          <ng-template #dummyTxt>
            <div class="dummyTxt"></div>
          </ng-template>
        </div>
        <div class="col" style="max-width: 160px;">
          <mdb-checkbox formControlName="rebajaStock">Rebaja stock</mdb-checkbox>
        </div>
        <div class="col">
          <div class="md-form">
            <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
              [filterEnabled]="true" formControlName="vendedor"></mdb-select>
            <span *ngIf="
                                            formHeader.get('vendedor').invalid &&
                                            (formHeader.get('vendedor').dirty ||
                                            formHeader.get('vendedor').touched)
                                          ">
              <mdb-error *ngIf="formHeader.get('vendedor').hasError('required')">
                Ingrese vendedor
              </mdb-error>
            </span>
          </div>
        </div>
        <div class="col">
          <div class="md-form">
            <mdb-select label="Condición de pago" [options]="optionsCondicionPago"
              placeholder="Seleccionar condición de pago" [filterEnabled]="true" formControlName="condicionPago">
            </mdb-select>
            <div *ngIf="
              formHeader.get('condicionPago').invalid &&
              (formHeader.get('condicionPago').dirty ||
              formHeader.get('condicionPago').touched)
            ">
              <mdb-error *ngIf="formHeader.get('condicionPago').hasError('required')">Ingrese condición de pago
              </mdb-error>
            </div>
          </div>
        </div>
      </div>


    </form>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button type="button" size="sm" mdbBtn color="info" (click)="showModalObservaciones()" mdbWavesEffect>
      Observaciones
    </button>
  </div>
</div>

<!-- <app-modal-seleccion-documento></app-modal-seleccion-documento> -->

<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()"></app-modal-seleccionar-cliente>

<app-modal-observaciones (onSelect)="saveObservaciones($event)"></app-modal-observaciones>